import { formatSaveNumber } from '@/slw/shared/ui/form/input';

import { HomeFilterType } from '../home/home.model';
import { AllModel, AllState, GetListingsRequest, ListingItem, SaveSearchData } from './search-results.type';

export const getHomeFilter = async () => {
  return apiClient().get<HomeFilterType>('/ecom/home/filter');
};

export const getListings = async (params: GetListingsRequest) => {
  return apiClient().get<ListingItem[]>('/ecom/home/find', {
    params: {
      ...params,
      fromYear: params.fromYear ? formatSaveNumber(params.fromYear) : null,
      toYear: params.toYear ? formatSaveNumber(params.toYear) : null,
      fromPrice: params.fromPrice ? formatSaveNumber(params.fromPrice) : null,
      toPrice: params.toPrice ? formatSaveNumber(params.toPrice) : null,
      fromOdometer: params.fromOdometer ? formatSaveNumber(params.fromOdometer) : null,
      toOdometer: params.toOdometer ? formatSaveNumber(params.toOdometer) : null,
    },
  });
};

export const getAllModel = async () => {
  return apiClient().get<AllModel[]>('/make-model/models');
};

export const getAllState = async () => {
  return apiClient().get<AllState[]>('/country-state/states');
};

export const onSaveSearch = async (searchData: SaveSearchData) => {
  if (searchData.id) {
    return apiClient().put('/ecom/home/user-search', searchData);
  }

  return apiClient().post('/ecom/home/user-search', searchData);
};

export const getSaveSearch = async () => {
  return apiClient().get<SaveSearchData[]>('/ecom/home/user-search');
};
